import { render, staticRenderFns } from "./TheNodeWitcher.vue?vue&type=template&id=809e4d92&scoped=true&"
import script from "./TheNodeWitcher.vue?vue&type=script&lang=js&"
export * from "./TheNodeWitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809e4d92",
  null
  
)

export default component.exports